<template>
    <v-layout row wrap>
        <v-flex xs12>
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    Optimisation Simulation
                </v-card-title>
                <v-card-text>
                    <v-layout>
                        <v-flex xs6>
                            <v-form v-model="valid" v-if="initialLoadDone">
                                <v-tabs v-model="active">
                                    <v-tab v-for="equip in equipmentList"
                                            :key="equip"
                                            ripple>
                                        {{ equip }}
                                    </v-tab>
                                    <v-tab-item v-for="equip in equipmentList"
                                                :key="equip">
                                        <v-card flat>
                                            <v-card-text>
                                                <v-switch
                                                        v-model="activeEquipments[equip]"
                                                        :label="`Active`"
                                                ></v-switch>
                                                <div v-if="activeEquipments[equip]">
                                                    <v-text-field v-for="varName in varList" :key="equip+varName"
                                                                  :label="varName"
                                                                  v-model.number="equipmentSettings[equip][varName]"
                                                                  type="number"
                                                                  v-bind:rules="fieldRules"
                                                                  required/>
                                                </div>
                                            </v-card-text>
                                        </v-card>
                                    </v-tab-item>
                                </v-tabs>
                            </v-form>
                        </v-flex>
                        <v-flex xs6>
                            <v-btn class="ml-4 mb-4" color="primary" :disabled="!valid" @click="runSym">
                                Run Simulation
                            </v-btn>
                            <div  v-if="!loading">
                            <value-box v-for="(item, index) in resultPower" :unit="'KW'"
                                       :value="item"
                                       class="ml-4 mb-4"
                                       icon=""
                                       :title="index + ' Power'"
                            >
                            </value-box>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-card-text>

            </v-card>
        </v-flex>




    </v-layout>
</template>

<script>
    import {callAPI} from '@/helper'
    import ValueBox from "../components/ValueBox";

    export default {
        name: 'OptimisationSimulation',
        components: {ValueBox },
        data () {
            return {
                fieldRules: [value => !!value || 'This value is required.',v => v > 0 || 'This value cannot be negative or null.'],
                valid:true,
                active: null,
                equipmentList: [],
                varList:[],
                equipmentSettings: {},
                loading:true,
                initialLoadDone:false,
                resultPower:null,
                activeEquipments:{},
                defaultSettings:{
                    'CHWS_Temp': 8,
                    'CHWR_Temp': 12,
                    'Outdoor_Air_Temperature': 30,
                    'Flow_Rate': 22,
                    'CHW_Temp_Diff': 4,
                    'on': 1,
                    'efficiency': 10,
                    'Comp_Power': 100,
                    'Cooling_Load': 4.2*4*22
                }

            }
        },
        methods:{
            runSym(){
                let me=this
                this.loading=true
                let list=[];
                let param={};
                for (let equip of this.equipmentList){
                    if(this.activeEquipments[equip]){
                        list.push(equip);
                        param[equip]=this.equipmentSettings[equip]
                    }
                }
                callAPI('optimizationsimulation/',{
                    equipment_list:list,
                    param:param
                }).then(function(result){
                    me.resultPower=result.data.power
                    me.loading=false;
                })
            }
        },
        mounted() {
            let me=this;
            let newEL=[];
            let newES={};
            let newAE={};
            for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
                let equip = this.$store.state.pointsListStore.pointsList.equipment_details[i]
                if( equip.equipment_type==="chiller"){
                    newEL.push(equip.equipment_name);
                    newES[equip.equipment_name]={...this.defaultSettings}
                    newAE[equip.equipment_name]=true
                }
                newEL.sort();
            }
            this.equipmentList=newEL;
            this.equipmentSettings=newES;
            this.activeEquipments=newAE;
            callAPI('optimizationsimulation/',{},'get').then(function(response){
                me.varList=response.data.variables;
                me.initialLoadDone=true;
            })
        }


    }
</script>
